import { OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.TEAM_WORKFLOW)
export default class TeamWorkflow extends BaseModel {
  @StringField()
  public id: string
}
